import React from 'react';
import { useQuery } from '../graphql/hooks';
import SimpleGrid from '../teal-react/components/organisms/SimpleGrid';
import K from '../Constants';
import SimpleTable from '../teal-react/components/organisms/SimpleTable';
import Loading from '../teal-react/components/molecules/Loading';
import Utils from '../teal-react/utils';
import { useNavigate } from 'react-router';
import APIClient from '../tools/APIClient';
import { useAuth } from '../teal-react/utils/token';
import QcSearch from '../components/QcSearch';

const Dashboard = () => {
  const navigate = useNavigate();
  const { token, user } = useAuth();
  const { data } = useQuery(
    `query Dashboard($untested: String, $pending: String, $approved: String){
      untested: qc(where: $untested, order: "date"){
        id
        date
        qc_code
        status
        product: product_id_product{
          id
          code
        }
      }
      pending: qc(where: $pending, order: "date"){
        id
        date
        qc_code
        status
        product: product_id_product{
          id
          code
        }
      }
      approved: qc(where: $approved, order: "approved_at desc", limit: 10){
        id
        date
        qc_code
        status
        product: product_id_product{
          id
          code
        }
      }
    }`,
    {
      pollInterval: 30000,
      variables: {
        untested: JSON.stringify({ status: K.status.UNTESTED }),
        pending: JSON.stringify({ status: K.status.PENDING }),
        approved: JSON.stringify({ status: K.status.APPROVED }),
      },
    }
  );
  React.useEffect(() => {
    // sso refresh
    if (!user?.isRO) {
      const api = new APIClient({ serverUrl: K.serverUrl });
      api.Post('/html/auth/sso.php', {
        data: { token },
      });
    }
    // eslint-disable-next-line
  }, [token]);

  if (!data) {
    return <Loading />;
  }

  const row_action = (r: any) => {
    navigate(`/products/${r.product?.id}/${r.id}`);
  };
  return (
    <SimpleGrid
      items={[
        {
          size: 3,
          content: (
            <SimpleTable
              header="Untested"
              data={data.untested}
              row_action={row_action}
              columns={[
                {
                  header: 'QC',
                  cell: 'qc_code',
                },
                {
                  header: 'Product',
                  cell: (r: any) => r.product?.code,
                },
                {
                  header: 'Date',
                  cell: (r: any) => Utils.date.formatDate(r.date),
                },
              ]}
            />
          ),
        },
        {
          size: 3,
          content: (
            <SimpleTable
              header="Pending Approval"
              data={data.pending}
              row_action={row_action}
              columns={[
                {
                  header: 'QC',
                  cell: 'qc_code',
                },
                {
                  header: 'Product',
                  cell: (r: any) => r.product?.code,
                },
                {
                  header: 'Date',
                  cell: (r: any) => Utils.date.formatDate(r.date),
                },
              ]}
            />
          ),
        },
        {
          size: 3,
          content: (
            <SimpleTable
              header="Recent Approvals"
              data={data.approved}
              row_action={row_action}
              columns={[
                {
                  header: 'QC',
                  cell: 'qc_code',
                },
                {
                  header: 'Product',
                  cell: (r: any) => r.product?.code,
                },
                {
                  header: 'Date',
                  cell: (r: any) => Utils.date.formatDate(r.date),
                },
              ]}
            />
          ),
        },
        {
          size: 3,
          content: <QcSearch />,
        },
      ]}
    />
  );
};
export default Dashboard;
